import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { authInterceptor } from './shared/interceptors/auth-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LocationStrategy, 
      useClass: PathLocationStrategy, 
    },
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideClientHydration(),
    provideToastr(),
    provideRouter(routes),
    { 
      provide: Storage, 
      useValue: localStorage
    },
      provideAnimationsAsync('animations'),
      providePrimeNG({
          theme: {
              preset: Aura,
              options: {
                prefix: 'p',
                darkModeSelector: 'false',
                cssLayer: {
                  name: 'primeng',
                  order: 'theme, base, primeng'
                }
            }
          }
      })
  ]
};
